import { IHttpApi } from '@cian/http-api';

export interface IDepositAmountWidgetParams {
  httpApi: IHttpApi;
  amount: number;
  transactionId?: string;
  paymentInitSource: EPaymentInitSource;
}

export type TDepositAmountWidgetResult = string;

export const enum EPaymentInitSource {
  /** Пакет */
  LkRealtorPackage = 'packageLkRealtor',
  /** Конструктор  */
  LkRealtorCustomPackage = 'customPackageLkRealtor',
  /** Подписка  */
  LkRealtorSubscription = 'subscriptionLkRealtor',
  /** Персональный пакет */
  LkRealtorPersonalPackage = 'personalPackageLkRealtor',
  /** Персональная подписка  */
  LkRealtorPersonalSubscription = 'personalSubscriptionLkRealtor',
  /** Смарт-пакет  */
  LkRealtorSmartPackage = 'smartPackageLkRealtor',
  /** Пополнение в сайд-баре лк соба  */
  LkOwnerDeposit = 'depositLkHomeowner',
  /** Пополнение в лк риелтора  */
  LkRealtorDeposit = 'depositLkRealtor',
  /** платёж для идентификации по карте в лк соба */
  LkOwnerIdentification = 'lkHomeownerIdentification',
  /** платёж для идентификации по карте в лк риелтора */
  LkRealtorIdentification = 'identificationLkRealtor',
  /** платёж для идентификации по карте на ФП */
  AddFormIdentification = 'publishObjectIdentification',
  /** пополнение на форме подачи */
  AddFormDeposit = 'publishObject',
}
